export const USER_ROLE = {
    SuperAdmin: "super_admin",
    AgencyAdmin: "agency_admin",
    Operator: "operator",
}
export const STATUS_TYPES = {
    pending: 'pending',
    fulfilled: 'fulfilled',
    rejected: 'rejected',
}
export const PERMISSIONS = {
    GeneralAccess: 'GeneralAccess',
    ReadUser: 'ReadUser',
    ManageUser: 'ManageUser',
    ReadSuperAdmin: 'ReadSuperAdmin',
    ManageSuperAdmin: 'ManageSuperAdmin',
    ReadUserGroup: 'ReadUserGroup',
    ManageUserGroup: 'ManageUserGroup',
    ReadCamera: 'ReadCamera',
    ManageCamera: 'ManageCamera',
    ReadCameraGroup: 'ReadCameraGroup',
    ManageCameraGroup: 'ManageCameraGroup',
    ReadCameraAcl: 'ReadCameraAcl',
    ManageCameraAcl: 'ManageCameraAcl',
    ReadEventLog: 'ReadEventLog',
    ReadAgency: 'ReadAgency',
    ManageAgency: 'ManageAgency',
    ReadPreset: 'ReadPreset',
    ManagePreset: 'ManagePreset',
    ManagePtz: 'ManagePtz',
    ManageCameraSynchronization: 'ManageCameraSynchronization',
    ReadStream: 'ReadStream',
    ManageTags: 'ManageTags',
    ManageRecording: 'ManageRecording'
}

export const ROUTE_PERMISSIONS = {
    '/': [],
    'liveview': [PERMISSIONS.ReadCamera, PERMISSIONS.ManagePtz, PERMISSIONS.ReadPreset, PERMISSIONS.ManagePreset, PERMISSIONS.ReadStream],
    'map': [PERMISSIONS.ReadCamera],
    'recording': [PERMISSIONS.ManageRecording],
    'management': [PERMISSIONS.ReadUser, PERMISSIONS.ManageUser, PERMISSIONS.ReadUserGroup, PERMISSIONS.ManageUserGroup,
    PERMISSIONS.ReadCamera, PERMISSIONS.ManageCamera, PERMISSIONS.ReadCameraGroup, PERMISSIONS.ManageCameraGroup,
    PERMISSIONS.ReadCameraAcl, PERMISSIONS.ManageCameraAcl, PERMISSIONS.ReadEventLog],
    'superAdmin': [PERMISSIONS.ReadSuperAdmin, PERMISSIONS.ManageSuperAdmin]
}

export const UNAUTHORIZED_STATUS_CODE = "401";
export const FORBIDDEN_STATUS_CODE = "403";


export const VideoCodecTypeEnum = {
  0: "Unknown",
  1: "H254Mpeg2",
  2: "H263Mpeg4",
  3: "H264Mpeg4",
  4: "H265",
  Unknown: 0,
  H254Mpeg2: 1,
  H263Mpeg4: 2,
  H264Mpeg4: 3,
  H265: 4
};
